<template>
    <page>
        <module title="定制服务详情">
            <div v-if="baseInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="姓名">{{baseInfo.name}}</c-detail-item>
                    <c-detail-item label="电话">{{baseInfo.phone}}</c-detail-item>
                    <c-detail-item label="公司">{{baseInfo.company}}</c-detail-item>
                    <c-detail-item label="邮箱">{{baseInfo.email}}</c-detail-item>
                    <c-detail-item label="地址" full>{{baseInfo.address}}</c-detail-item>
                    <c-detail-item label="提交时间" full>{{baseInfo.create_date}}</c-detail-item>
                    <c-detail-item label="处理人" v-if="baseInfo.state == 2">{{baseInfo.deal_user_realname||'--'}}</c-detail-item>
                    <c-detail-item label="处理时间" v-if="baseInfo.state == 2">{{baseInfo.deal_date||'--'}}</c-detail-item>
                    <c-detail-item label="处理意见" full v-if="baseInfo.state == 2">{{baseInfo.deal_suggest||'--'}}</c-detail-item>

                    <c-detail-item label="定制产品" full>
                        <c-table v-model="productList" :paging="false" height="auto" border>
                            <c-table-column
                                    label="产品号"
                                    name="product_number"
                            >
                            </c-table-column>
                            <c-table-column
                                    label="产品中文名"
                                    name="product_name"
                            >
                            </c-table-column>
                            <c-table-column
                                    label="产品英文名"
                                    name="product_name_en"
                            >
                            </c-table-column>
                            <c-table-column
                                    label="产品CAS号"
                                    name="product_cas_number"
                            >
                            </c-table-column>
                            <c-table-column
                                    label="浓度"
                                    name="concentration"
                            >
                            </c-table-column>
                        </c-table>
                    </c-detail-item>

                    <c-detail-item label="含组分数">{{extraData.group_scores}}</c-detail-item>
                    <c-detail-item label="指定溶剂">{{extraData.specified_solvent}}</c-detail-item>
                    <c-detail-item label="包装规格">{{extraData.packing_spec}}</c-detail-item>
                    <c-detail-item label="包装个数">{{extraData.packing_count}}</c-detail-item>
                    <c-detail-item label="需求时间">{{extraData.required_time  }}</c-detail-item>
                    <c-detail-item label="其他">{{extraData.others}}</c-detail-item>
                    <c-detail-item label="备注" full>{{extraData.remark}}</c-detail-item>
                </c-detail>
            </div>
            <template slot="button">
                <c-button power="b_custom_deal" size="m" v-if="baseInfo.state == 1" hollow @click="handleData()">处理</c-button>
            </template>
        </module>
        <c-dialog ref="dialog" title="处理反馈问题" width="600" height="300" @resolve="handleDeal">
            <c-form ref="form">
                <c-form-item type="hidden" name="state" value="2"></c-form-item>
                <c-form-item type="textarea" label="处理意见：" name="deal_suggest"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'custom_detail',

        props: {
            id: String
        },

        components: {
        },

        data() {
            return {
                baseInfo: '',
                extraData: '',
                productList: [],
                activitynoticeText: ''
            }
        },

        computed: {
        },

        watch: {
            id() {
                this.getDataDetail();
            }
        },

        mounted() {
            this.getDataDetail();
        },

        methods: {
            getDataDetail() {
                this.request({
                    url: '/website/feedback/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.baseInfo = data;
                        if (data.extra_data_map){
                            this.extraData = data.extra_data_map;
                        }
                        if (data.extra_data_map && data.extra_data_map.product_list){
                            this.productList = data.extra_data_map.product_list;
                        }
                    }
                });
          },
        /**
         * 处理数据
         */
          handleData(){
                this.$refs.dialog.open();
          },
          handleDeal(stop) {
                stop();
                var data = this.$refs.form.serialize();
                if (!data.state) {
                    this.$message({
                        text: '请选择状态'
                    });
                    return;
                }
                if (!data.deal_suggest) {
                    this.$message({
                        text: '请输入处理意见'
                    });
                    return;
                }

                this.request({
                    url: 'website/feedback/deal',
                    data: Object.assign(data, {
                        id: this.id
                    }),
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '处理成功'
                        });
                        this.$refs.dialog.close();
                        this.getDataDetail();
                    }
                });
            },
        }
    }
</script>